var map = {
	"./app_cloudpets_net": "738e",
	"./app_cloudpets_net.js": "738e",
	"./app_dudupets_com": "03dc",
	"./app_dudupets_com.js": "03dc",
	"./guqin_moemone_com": "77d9",
	"./guqin_moemone_com.js": "77d9",
	"./petnetizen_cloudpets_net": "8d1d",
	"./petnetizen_cloudpets_net.js": "8d1d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d616";